// LoginPage.js

import React, { useState, useEffect } from 'react';
import './styles.css';
import axios from 'axios';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';
import { Link } from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';




const ControlPanel = ({ controlPanel }) => {
    const [donutChartData,setDonutChartData] = useState([]); // Insira seus dados do grid aqui
    const [painelChartData,setPainelChartData] = useState([]); // Insira seus dados do grid aqui
    const [gridDataLast5,setGridDataLast5] = useState([]); // Insira seus dados do grid aqui

  useEffect(() => {
    if (localStorage.getItem("user") === null) {
      window.location.href = "/";
    }
    else {
      const data = JSON.parse(localStorage.getItem("user"));

      const fetchData = async () => {
        const requestBody = new FormData();
        requestBody.append('companyID', data.companyID);

        try {
          const response = await fetch(process.env.REACT_APP_BASE_URL + '/api/ReturnCounters', {
            method: 'POST',
            body: requestBody
          });

          if (!response.ok) {
            throw new Error('Error occurred while fetching data.');
          }

          const data = await response.json();
          setDonutChartData(data);
        } catch (error) {
          console.error(error);
        }

        try {
          const response = await fetch(process.env.REACT_APP_BASE_URL + '/api/ReturnCountersData', {
            method: 'POST',
            body: requestBody
          });

          if (!response.ok) {
            throw new Error('Error occurred while fetching data.');
          }

          const data = await response.json();

          const sortedData = data.sort((a, b) => {
            // Converta as datas para o formato MM/DD/YYYY antes de criar objetos Date
            const convertToDate = (dateString) => {
                const [day, month, year] = dateString.split('/');
                return new Date(`${month}/${day}/${year}`);
            };
        
            const dateA = convertToDate(a.Description);
            const dateB = convertToDate(b.Description);
        
            // Compare as datas e retorne o resultado da comparação
            return dateA - dateB;
        });

          setPainelChartData(sortedData);
        } catch (error) {
          console.error(error);
        }

        try {
          requestBody.append('limit', 5);
            const response = await fetch(process.env.REACT_APP_BASE_URL + '/api/ReadData', {
              method: 'POST',
              body: requestBody
            });
  
            if (!response.ok) {
              throw new Error('Error occurred while fetching data.');
            }

            const data = await response.json();
            
            setGridDataLast5(data);
          } catch (error) {
            console.error(error);
          }
      
      };

      fetchData();
      } 

    },[]);

    function getStatus(status) {
      switch (status.toLowerCase()) {
        case "processado":
          return "badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill";
        case "erro":
          return "badge bg-danger-subtle border border-danger-subtle text-danger-emphasis rounded-pill";
        case "em processamento":
          return "badge bg-warning-subtle border border-warning-subtle text-warning-emphasis rounded-pill";
        default:
          return "";
      }
    }

    // Configuraçao dos graficos
    var chartDonutOptions;
    var chartLineOptions;

    function chatDunet() {
      chartDonutOptions = {
        tooltip: {
          trigger: 'item'
        },
        series: donutChartData.map(item => item.Counter),
        labels: donutChartData.map(item => item.Description),
        legend: {
          position: 'bottom',
          fontSize: '15px'
        }
      };
    }

    function chartLine() {
      const lineDataValues = painelChartData.map(item => item.Counter);
      const lineDataCategories = painelChartData.map(item => item.Description);
    
      chartLineOptions = {
        series: [{
          name: 'Arquivos processados',
          data: lineDataValues
        }],
        forecastDataPoints: {
          count: 7
        },
        stroke: {
          width: 5,
          curve: 'smooth'
        },
        xaxis: {
          categories: lineDataCategories,
          tickAmount: 10,
          labels: {
            formatter: function(value) {
              return value;
            }
          }
        },
        title: {
          text: 'Resumo',
          align: 'left',
          style: {
            fontSize: "16px",
            color: '#666'
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            gradientToColors: ['#FDD835'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 100, 100]
          },
        },
        yaxis: {
          min: 0,
          max: 500
        },
      };
    }

    chartLine();
    chatDunet();
          
  return (
    <div className='container-fluid p-0'>
      <HeaderLogged></HeaderLogged>
      {/* <Menu></Menu> */}
      <div className="row showContentMargin" id='content'>
        <div className="col-3 col-lg-auto col-xxl-2" id='divSidebar'>
          <Sidebar></Sidebar>
        </div>
        <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>

          <div className="row">

            <div className="col-12 mt-2">
              <div className="card h-100 shadow">
                <div className="card-body">
                  <h3 className="card-title">Arquivos Processados na última semana.</h3>

                  <ReactApexChart options={chartLineOptions} series={chartLineOptions.series} type="line" height={375} />

                </div>
              </div>
            </div>

            <div className="col-lg-6 mt-4">
              <div className="card h-100 shadow">
                <div className="card-body">
                  <h3 className="card-title text-center">Arquivos Processados.</h3>

                  <ReactApexChart options={chartDonutOptions} series={chartDonutOptions.series} type="donut" height={425} />

                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-4">
              <div className="card h-100 shadow">
                <div className="card-body">
                <h4 className="card-title text-center">Últimos 5 documentos processados.</h4>
                  <ul className='list-group list-group-flush mt-4'>

                    {gridDataLast5.map((item) => (
                      <li className='list-group-item' key={item.ID}>
                        <div className="row">
                          <h6>{item.ProcessDate && item.ProcessDate + " -"} Id Externo: {item.externalID}</h6>
                          <div className="col-sm-9">
                            {item.batchID === null ? (<p>{item.fileName}</p>) : (<p>Lote: {item.ID}</p>)}
                          </div>
                          <div className="col-sm-3">
                            <p className={getStatus(item.Status)}>{item.Status}</p>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ControlPanel;

